<template>
  <div class="video-wrap">
    <div class="video-title">
      <!-- {{ item.districtName + '-' + item.culturaCompanyName + '-' + item.name }} -->
      <span v-if="viewMode === 'static'" @click="closeVideo"></span>
    </div>
    <video-player
    v-if="!showErrow"
    ref="videoplayer"
    class="vjs-custom-skin"
    :playsinline="false"
    :options="playerOptions"
    @play="onPlayerPlay($event)"
    @pause="onPlayerPause($event)"
    @ended="onPlayerEnded($event)"
    @waiting="onPlayerWaiting($event)"
    @playing="onPlayerPlaying($event)"
    @loadeddata="onPlayerLoadeddata($event)"
    @timeupdate="onPlayerTimeupdate($event)"
    @canplay="onPlayerCanplay($event)"
    @canplaythrough="onPlayerCanplaythrough($event)"
    @statechanged="playerStateChanged($event)"
    @ready="playerReadied"></video-player>
    <div v-else class="errow">
      此视频资源暂无法播放，请查看后再试
    </div>
  </div>
</template>

<script>

import { videoPlayer } from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
// import 'videojs-contrib-hls' // 有m3u8时用
import 'videojs-flash'

export default {
  name: 'ZjVideoPlayer',
  props: {
    viewMode: {
      type: String
    },
    item: {
      type: Object
    },
    url:{
      type: String
    }
  },
  components: {
    videoPlayer
  },
  computed: {
    player() {
      return this.$refs.videoplayer.player
    }
  },
  data() {
    return {
      showErrow: false,
      playerOptions: {
        // height: '460',
        language: 'zh-CN',
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        // aspectratio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        // fluid: true, // 当true时，video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        // hls:true, //如果是播放m3u8必须加（需注释掉techorder,不然会有报错）
        // html5: { hls: { withCredentials: false }}, // 可以使用m3u8
        techOrder: ['flash'], //播放rtmp必须加
        flash: {
          hls: {
            withCredentials: false
          }
        },
        sources: [{
          type: 'application/x-mpegurl',
          // withCredentials: false,
          src: 'rtmp://58.200.131.2:1935/livetv/cctv1'//'http://m.qhdxdzy.com:2998/hls/shgtxdyg/playlist.m3u8'//"rtmp://58.200.131.2:1935/livetv/cctv1"
        }],
        controls: true,
        poster: '', //你的封面地址
        notSupportedMessage: '此视频资源暂无法播放，请查看后再试', //允许覆盖video.js无法播放媒体源时显示的默认信息。
        controlbar: {
          timedivider: true, // 当前时间和持续时间的分隔符
          durationdisplay: true, // 显示持续时间
          remainingtimedisplay: false, // 是否显示剩余时间功能
          fullscreentoggle: true // 是否显示全屏按钮
        }
      }
    }
  },
  created() {
   // let videoType = this.getVideoType(this.item.url)
    this.playerOptions.sources[0].src = this.url
    // if (videoType === 'rtsp') {
    //   this.showErrow = true
    // } else {
    //   this.showErrow = false 
    // }
  },
  beforeUpdate() {

  },
  updated() {
    let videoType = this.getVideoType(this.item.url)
    this.playerOptions.sources[0].src = this.url
    if (videoType === 'rtsp') {
      this.showErrow = true
    } else {
      this.showErrow = false 
    }
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    closeVideo() {
    //  let index = this.item.index
      this.$emit('destoryVideo', this.item) 
    },
    // 判断视频类型
    getVideoType(url) {
      let str = url.split('://')[0]
      let typeStr = url.split('.')
      let type = typeStr[typeStr.length - 1] === 'm3u8' ? 'hls' : ''
      switch (str) {
        case 'rtsp':
          type = 'rtsp'
          break
      case 'rtmp':
          type = 'rtmp'
          break
      
        default:
          break
      }
      return type
    },
    //点击全屏播放
    handlefullscreen(index){
      console.log(index)
      const player = this.$refs.videoplayer.player
      player.requestfullscreen();//调用全屏api方法
      player.isfullscreen(true)
      player.play()
    },
    // 播放回调
    onPlayerPlay(player) {
      // this.$emit('set-play', 'play')
      console.log('player play!', player)
    },

    // 暂停回调
    onPlayerPause(player) {
      // this.$emit('set-play', 'pause')
      console.log('player pause!', player)
    },

    // 视频播完回调
    onPlayerEnded(player) {
      console.log(player)
    },

    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting(player) {
      console.log('DOM元素上的readyState更改导致播放停止', player)
    },

    // 已开始播放回调
    onPlayerPlaying(player) {
       console.log(player)
    },

    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata(player) {
       console.log(player)
    },

    // 当前播放位置发生变化时触发。
    onPlayerTimeupdate(player) {
       console.log(player)
    },

    //媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay(player) {
       console.log('player Canplay!', player)
    },

    //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough(player) {
       console.log('player Canplaythrough!', player)
    },

    //播放状态改变回调
    playerStateChanged(playerCurrentState) {
       console.log('player current update state', playerCurrentState)
    },

    //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied(player) {
      // this.$refs.videoplayer.player.play()
      console.log('example player 1 readied', player);
    }
  }
}
</script>

<style lang="scss" scoped>
.video-wrap {
  position: relative;
}
.video-wrap, .video-player {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.video-title {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 50/1080*100vh;
  padding: 0 20/100*1rem;
  font-size: 16/100*1rem;
  line-height: 50/1080*100vh;
  background-color: rgba(0, 0, 0, .5);
  span {
    position: absolute;
    right: 10px;
    top: 0;
    width: 30/1080*100vh;
    height: 50/1080*100vh;
  //  background: url('~@/assets/images/close.png') no-repeat center center;
    background-size: 20/1080*100vh 20/1080*100vh;
    cursor: pointer;
  }
}
.errow {
  width: 100%;
  height: 100%;
  padding-top: 50px;
  box-sizing: border-box;
  background: #000;
  color: #fff;
  font-size: 14px;
  text-align: center;
}
.vjs-custom-skin > .video-js {
  height: 100%;
}
.vjs-custom-skin > .video-js .vjs-big-play-button {
  height: 1.4em !important;
  line-height: 1.4em !important;
}
</style>